import { render, staticRenderFns } from "./RegistrationBanner.vue?vue&type=template&id=505b3109"
import script from "./RegistrationBanner.vue?vue&type=script&lang=js"
export * from "./RegistrationBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports